exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-frontpage-frontpage-template-tsx": () => import("./../../../src/templates/frontpage/frontpage-template.tsx" /* webpackChunkName: "component---src-templates-frontpage-frontpage-template-tsx" */),
  "component---src-templates-page-page-template-tsx": () => import("./../../../src/templates/page/page-template.tsx" /* webpackChunkName: "component---src-templates-page-page-template-tsx" */)
}

